import parse from "html-react-parser";
import NextImage from "./NextImage";

export default function PostContent({ description }) {
  return (
    <div className={"content"}>
      {parse(description, {
        replace: element => {
          // console.dir(element, { depth: null });
          if (element.name === "img") {
            return (
              <div className={"imageWrapper imageInContent"}>
                <NextImage
                  layout={"responsive"}
                  src={element.attribs.src}
                  alt={element.attribs.alt}
                  width={880}
                  height={580}
                  object={"cover"}
                  placeholder="blur"
                />
              </div>
            );
          }
        },
      })}
    </div>
  );
}
